var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#515864",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.143 28.571A3.439 3.439 0 0113.714 32a3.428 3.428 0 01-3.423-3.241l-.005-.188h6.857zM13.714 0c1.366 0 2.48.984 2.566 2.232l.006.158v1.083c4.805 1.062 7.6 5.015 7.71 9.776l.004.292v8.52c-.58.35-.968.987-.968 1.714l-.001 1.302-.098-.09a1.992 1.992 0 00-1.312-.491h-.157l-.15.005a2 2 0 00-1.84 1.784H0v-1.592l3.429-3.187v-7.965c0-4.808 2.683-8.821 7.421-10l.293-.068V2.39c0-1.323 1.148-2.39 2.571-2.39zm7.907 25.496a1 1 0 01.978.79h-2.113a1 1 0 01.861-.783l.117-.007h.157z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.326 31.527V17a1 1 0 00-1-1h-.157a1 1 0 00-1 1v14.527h-1.411V20.32a1 1 0 00-1-1H28.6a1 1 0 00-1 1v11.206h-1.412v-7.752a1 1 0 00-1-1h-.157a1 1 0 00-1 1v7.752H22.62v-5.031a1 1 0 00-1-1h-.157a1 1 0 00-1 1v5.03h-1.332c-.073 0-.132.107-.132.237s.06.237.132.237h15.525c.073 0 .132-.107.132-.237 0-.131-.058-.236-.132-.236h-1.331z"
  })))));
}
export default SvgReports;